import { createApp } from 'vue';
import { formatDateByLocale } from '../yfantis.js';
jQuery(function($) {

    if ($("#YF-content-eventlist").length === 1) {
        createApp({
            data: () => ({
                events: [],
                currentLocale: 'nl_NL',
                activeEvent: {description: ''},
                calendarName: ''
            }),
            mounted() {
                this.getEvents();
                this.currentLocale = currentLocale;
                this.calendarName = calendarName;
            },
            methods: {
                formatDateByLocale,
                getEvents: function() {
                    this.events = eventsAsJson;
                },
                getEndTime: function(startTime, duration) {
                    let endTime = '', startTimeUTF = '.000Z';
                    if (duration === '1440') {
                        return "whole day"; // fixme: translation
                    } else {
                        // should be something like 2044-12-31T23:00:00.000Z
                        startTimeUTF = startTime.replace(" ", "T") + startTimeUTF;
                        endTime = moment(startTimeUTF).add(duration, 'minutes');
                        // just the time is relevant. don't use summer/wintertime (utc)
                        return moment.utc(endTime).format('HH:mm');
                    }
                    return endTime;
                },
                setActiveEvent(event) {
                    console.log("setting active event " + event.id);
                    this.activeEvent = event;
                }
            }
        }).mount('#YF-content-eventlist');
    }

    // Calendar tabs functionality
    if ($("#calendarTabs").length === 1) {
        // Initialize Bootstrap tabs
        $('#calendarTabs button[data-toggle="tab"]').on('click', function (e) {
            e.preventDefault();
            $(this).tab('show');
        });

        // Ensure first tab is active on page load
        $('#calendarTabs button:first').tab('show');
    }
});
